import PropTypes from 'prop-types';

export const FilterOptionPropType = PropTypes.shape({
  name: PropTypes.string,
  render: PropTypes.func,
  actionableFilterPill: PropTypes.object, // gotta hunt this down too
  displayName: PropTypes.node,
  expectsArgumentsAsArray: PropTypes.bool,
  filterValue: PropTypes.string,
  id: PropTypes.string,
  shouldHideActionButtons: PropTypes.bool,
  type: PropTypes.string,
});

/**
 * @typedef {object} FilterOptionPropType
 * @property {string} name
 * @property {Function} render
 * @property {object} actionableFilterPill
 * @property {JSX.Element} displayName
 * @property {bool} expectsArgumentsAsArray
 * @property {string} filterValue
 * @property {string} id
 * @property {boolean} shouldHideActionButtons
 * @property {string} type
 */
